/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmailInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Prompt from 'DesignSystem/Questions/Prompt/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function EmailInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/EmailInput",
  onChange
  
}) {
let questionIdValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'id',
format: fromHelpers.getPrompt,
})
let contactDetailsEmaildetailsEmailaddressValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'emailDetails.emailAddress',
})
let contactDetailsEmaildetailsEmailaddressChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'emailDetails.emailAddress',
})
let contactDetailsEmaildetailsIsvalidValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'emailDetails.isValid',
})
let contactDetailsEmaildetailsEmailaddressValueData1 = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'emailDetails.emailAddress',
})
let aggregateData = fromHelpers.markAsInvalid(contactDetailsEmaildetailsIsvalidValueData, contactDetailsEmaildetailsEmailaddressValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
 data="question.id"
 format="./helpers.js getPrompt"
 text={questionIdValueData}
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 placeholder="you@example.com"
 width={250}
 marginTop={0}
 flexGrow={0}
 paddingLeft={0}
 paddingTop={dtSpaceXs}
 backgroundColor="transparent"
 required={true}
 data="contactDetails.emailDetails.emailAddress"
 value={contactDetailsEmaildetailsEmailaddressValueData}
 onChange={contactDetailsEmaildetailsEmailaddressChangeData}
 data="contactDetails.emailDetails.isValid"
 data="contactDetails.emailDetails.emailAddress"
 aggregate="helpers.js markAsInvalid"
 invalid={!aggregateData}
 type="text"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXs}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 textTransform="lowercase"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}